// src/components/BoardPackConfiguration/common/BoardPackLayout.jsx

import React from "react";
import mawgifLogo from "@/assets/img/unnamed_1.png";
import footerLogo1 from "@/assets/img/images.png";
import footerLogo2 from "@/assets/img/ACI_Logo.svg.png";

export const BoardPackLayout = ({ children, isSidebar = true, isFooter = true }) => {
  return (
   <div className="relative overflow-hidden bg-card">
         <div className="origin-top-left">
           <div className="flex relative">
   
             {/* Left Sidebar  */}
             {isSidebar && (
               <div className="flex w-28 sm:w-36 md:w-48 lg:w-56 xl:w-64 bg-[#006fc0] items-center justify-center absolute left-0 top-0 h-full">
                 <img
                   src={mawgifLogo}
                   alt="Mawgif Logo"
                   className="w-16 sm:w-20 md:w-28 lg:w-32 xl:w-36 object-contain"
                 />
               </div>
             )}
   
             {/* Top Right L Shape */}
             <div className="absolute top-1 right-2 z-10 pointer-events-none">
               <div className="relative">
                 <div className="w-10 h-3 bg-[#006fc0]" />
                 <div className="absolute top-0 -right-0.5 w-3 h-10 bg-[#006fc0]" />
               </div>
             </div>
   
             {/* Main Content */}
             <div
               className={`flex-1 relative ${isSidebar ? "ml-28 sm:ml-36 md:ml-48 lg:ml-56 xl:ml-64" : "ml-0"
                 }`}
             >
               <div>
                 <div>{children}</div>
               </div>
             </div>             
   
             {/* Footer Logos */}
             {isFooter && (
               <div className="absolute bottom-1 right-2 flex gap-2 sm:gap-3 md:gap-4 items-center z-10">
                 <img src={footerLogo1} alt="Footer Logo 1" className="h-14 object-contain" />
                 <img src={footerLogo2} alt="Footer Logo 2" className="h-14 object-contain" />
               </div>
             )}
           </div>
         </div>
       </div>
  );
};
